import SocialIconList from './SocialIconListComponent'

export default SocialIconList
